import { createContext, useContext } from 'react';

/**
 * Onde a celula esta sendo desenhada: na linha da TABELA ou no CARTAO que a
 * substitui abaixo de 768 px (R01, p.28).
 *
 * A mesma `celula` da coluna serve aos dois, e o texto longo precisa de
 * regras diferentes em cada um. Na tabela ele vai a no maximo duas linhas,
 * para a linha nao crescer sem fim; no cartao sobra altura, e cortar ali seria
 * esconder texto que cabe. Quem monta a celula pergunta aqui, em vez de
 * adivinhar pela largura da janela.
 */
export type ModoDaCelula = 'tabela' | 'cartao';

export const ContextoDaCelula = createContext<ModoDaCelula>('tabela');

export function useModoDaCelula(): ModoDaCelula {
  return useContext(ContextoDaCelula);
}

/**
 * Se a celula da coluna pode quebrar linha (p.18).
 *
 * "Celula nao quebra" vale para o que se compara na vertical: CODIGO (tem o
 * proprio `codigo`, que ja nao quebra), NUMERO e STATUS — "CAM-" em cima de
 * "001", "4.150,0" em cima de "h" e "Em" em cima de "manutencao" deixam de
 * ser o dado. Nome, obra, descricao e frase de situacao vao a duas linhas: com
 * elas presas numa linha so, a largura minima da tabela virava a soma das
 * frases mais longas, e o quadro cortava a ultima coluna no meio da palavra.
 *
 * A coluna de texto que nao pode quebrar (data com hora, por exemplo) declara
 * `quebra: 'nunca'`.
 */
export function quebraDaColuna(coluna: {
  readonly alinhamento?: 'texto' | 'numero' | 'status';
  readonly quebra?: 'nunca' | 'duas-linhas';
}): 'nunca' | 'duas-linhas' {
  if (coluna.quebra) return coluna.quebra;
  return coluna.alinhamento === 'numero' || coluna.alinhamento === 'status' ? 'nunca' : 'duas-linhas';
}
